import { useState, useEffect, useCallback } from "react";
import Select, { MultiValue, StylesConfig } from "react-select";
import { Option } from "../../interface/Option";
import { ActivityCodeAxiosInstance } from "../../Network/ActivityCodeAxiosInstance";

const ListofActivityCode = ({ onChange, clear, defaultValue, type }: any) => {
  const [options, setOptions] = useState<Option[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<Option[]>([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState<string>("");

  const loadOptions = useCallback(async () => {
    if (!type || inputValue.trim().length < 3) {
      setOptions([]);
      return;
    }

    setLoading(true);
    try {
      const response = await ActivityCodeAxiosInstance.get(`/getActivityCode/${type}`, {
        params: { search: inputValue },
      });

      const data = response.data?.result || [];
      const formattedOptions: Option[] = data.map((item: any) => ({
        value: item?.activity,
        label: `${item?.activity} - ${item?.activity_description}`,
      }));

      setOptions(formattedOptions);
    } catch (error) {
      console.error("Error loading activity codes:", error);
    } finally {
      setLoading(false);
    }
  }, [type, inputValue]);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      loadOptions();
    }, 300);
    return () => clearTimeout(debounceTimeout);
  }, [inputValue, loadOptions]);

  const handleChange = (selected: MultiValue<Option>) => {
    setSelectedOptions(selected as Option[]);
    onChange(selected as Option[]);
  };

  useEffect(() => {
    if (clear) {
      setSelectedOptions([]);
    }
  }, [clear]);

  useEffect(() => {
    if (defaultValue) {
      setSelectedOptions(defaultValue);
    }
  }, [defaultValue]);

  const customStyles: StylesConfig<Option, true> = {
    menuPortal: (base) => ({
      ...base,
      zIndex: 99999,
      pointerEvents: "all",  // â† Ù…Ù‡Ù… Ù„Ø­Ù„ Ù…Ø´ÙƒÙ„Ø© Ø§Ù„ÙƒÙ„ÙŠÙƒ
    }),
    menu: (base) => ({
      ...base,
      zIndex: 99999,
      pointerEvents: "all",  // â† Ù…Ù‡Ù… Ù„Ø­Ù„ Ù…Ø´ÙƒÙ„Ø© Ø§Ù„ÙƒÙ„ÙŠÙƒ
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: "200px",
      overflowY: "auto",
      pointerEvents: "all",  // â† Ù…Ù‡Ù… Ù„Ø­Ù„ Ù…Ø´ÙƒÙ„Ø© Ø§Ù„ÙƒÙ„ÙŠÙƒ
    }),
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#007BFF",
      color: "#FFFFFF",
      borderRadius: "5px",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: "#FFFFFF",
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: "#FFFFFF",
      ":hover": {
        backgroundColor: "#0056b3",
        color: "#FFFFFF",
      },
    }),
    option: (styles, { isSelected, isFocused }) => ({
      ...styles,
      backgroundColor: isSelected ? "#007BFF" : isFocused ? "#e6f0ff" : "#FFFFFF",
      color: isSelected ? "#FFFFFF" : "#000000",
      cursor: "pointer",  // â† ÙŠØ®Ù„ÙŠ Ø§Ù„ÙƒÙŠØ±Ø³Ø± pointer Ø¹Ø´Ø§Ù† ÙˆØ§Ø¶Ø­ Ø§Ù†Ù‡ Ù‚Ø§Ø¨Ù„ Ù„Ù„ÙƒÙ„ÙŠÙƒ
      ":hover": {
        backgroundColor: "#0056b3",
        color: "#FFFFFF",
      },
    }),
  };

  return (
    <Select
  isMulti
  value={selectedOptions}
  onChange={handleChange}
  options={options}
  isLoading={loading}
  onInputChange={setInputValue}
  placeholder="Type at least 3 letters to search..."
  styles={customStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
  onMenuOpen={() => {
    setTimeout(() => {
      const menuEl = document.querySelector(".select__menu");
      if (menuEl) {
        (menuEl as HTMLElement).style.pointerEvents = "all";
        (menuEl as HTMLElement).style.zIndex = "99999";
      }
    }, 0);
  }}
/>
  );
};

export default ListofActivityCode;
